module.exports = ".page-header {\n  min-height: 225px;\n  height: 50vh; }\n"